import React from "react";
import { NewButton } from "components/common";
import CreditScoreChart from "../CreditScore/CreditScoreChart";

/**
 * @param {Object} props
 * @param {string} props.className
 * @param {number} props.creditScore
 * @param {boolean} props.isBlurred
 * @param {boolean} props.isEnrollable
 * @param {Function} props.onEnrollClick
 * @returns
 */
const CreditScore = (props) => {
  const {
    className = "",
    creditScore,
    isBlurred,
    isEnrollable,
    onEnrollClick,
  } = props;

  return (
    <div
      className={`flex flex-col bg-white items-center justify-center px-8 py-12 ${className}`}
    >
      <CreditScoreChart creditScore={creditScore} isBlurred={isBlurred} />
      <div className="mt-10 text-center">
        {isBlurred ? (
          <>
            <p className="text-black text-center text-2xl font-bold">
              Stay on top of your credit score - for FREE
            </p>
            <NewButton
              colorVariant="secondary-light"
              className="w-full self-center mt-4"
              disabled={!isEnrollable}
              onClick={onEnrollClick}
            >
              Get my score
            </NewButton>
          </>
        ) : (
          <>
            <p className="text-2xl text-center font-bold">Your Credit Score</p>
            <p className="text-green-700 my-4 text-2xl font-bold">Today</p>
            <p className="text-xs font-semibold">
              We check for updates once a month
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default CreditScore;
